import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "materialize-css/dist/css/materialize.min.css";
import "../styles/_ui-elements.scss";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../firebase";
import { FirebaseService } from "../services/firebase.service";
import { query, collection, where, getDocs } from "firebase/firestore";

const homeIcon = require("../assets/sidenav/home.png");
const pointsIcon = require("../assets/sidenav/points.png");
const rewardsIcon = require("../assets/sidenav/rewards.png");
const brandsIcon = require("../assets/sidenav/brands.png");
const connectionsIcon = require("../assets/sidenav/connections.png");
const experiencesIcon = require("../assets/sidenav/experiences.png");
const profileIcon = require("../assets/sidenav/profile.png");
const profileImage = require("../assets/profile-image.png");

export const Sidenav = () => {
  const [user, loading] = useAuthState(auth);
  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  const fetchUserName = async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      console.log(data);
      setUsername(data.username);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (loading) return;
    if (!user) {
      return navigate("/");
    } else {
      fetchUserName();
    }
  }, [user, loading]);

  return (
    <div className="sidenav-container">
      <ul id="slide-out" className="sidenav">
        <li className="sidenav-close-container">
          <a className="sidenav-close text-main">x Close</a>
        </li>
        {user && (
          <li className="image-wrapper">
            <img src={profileImage} alt="" />
            <div className="user-labels">
              <span className="text-description">{username}</span>
              <span className="text-small">{user?.email}</span>
            </div>
          </li>
        )}
        <li>
          <Link to={"/dashboard"}>
            <img src={homeIcon} />
            <span className="text-main">Home</span>
          </Link>
        </li>
        <li>
          <Link to={"/wallet"}>
            <img src={experiencesIcon} />
            <span className="text-main">Wallet</span>
          </Link>
        </li>
        <li>
          <Link to={"/dashboard"}>
            <img src={pointsIcon} />
            <span className="text-main">Points</span>
          </Link>
        </li>
        <li>
          <Link to={"/dashboard"}>
            <img src={rewardsIcon} />
            <span className="text-main">Rewards</span>
          </Link>
        </li>
        <li>
          <Link to={"/brands"}>
            <img src={brandsIcon} />
            <span className="text-main">Brands</span>
          </Link>
        </li>
        <li>
          <Link to={"/dashboard"}>
            <img src={connectionsIcon} />
            <span className="text-main">Connections</span>
          </Link>
        </li>
        <li>
          <Link to={"/dashboard"}>
            <img src={experiencesIcon} />
            <span className="text-main">Experiences</span>
          </Link>
        </li>
        {user && (
          <>
            <div className="divider" />
            <li>
              <Link to={"/dashboard"}>
                <img src={profileIcon} />
                <span className="text-main">Profile</span>
              </Link>
            </li>
            <li className="profile-label">
              <Link to={"/dashboard"}>
                <span className="text-small">Preferences</span>
              </Link>
            </li>
            <li className="profile-label">
              <Link to={"/dashboard"}>
                <span className="text-small">History</span>
              </Link>
            </li>
            <li className="profile-label">
              <Link to={"/dashboard"}>
                <span className="text-small">Data</span>
              </Link>
            </li>
            <li className="profile-label sidenav-close">
              <Link to={"/dashboard"} onClick={FirebaseService.logout}>
                <span className="text-small">Sign out</span>
              </Link>
            </li>
          </>
        )}
      </ul>
      <a data-target="slide-out" className="sidenav-trigger">
        <i className="material-icons">menu</i>
      </a>
    </div>
  );
};

export default Sidenav;
